import { useState } from 'react'
import { MegaphoneIcon, SendIcon, XIcon } from '../icons'
import type { PublicUser } from '../types'
import { API_URL, getAuthHeaders } from '../api'

export function BroadcastModal({ recipients, onClose }: { recipients: PublicUser[]; onClose: () => void }) {
  const [message, setMessage] = useState('')
  const [sending, setSending] = useState(false)
  const [sent, setSent] = useState(0)
  const [failed, setFailed] = useState<string[]>([])
  const [done, setDone] = useState(false)


  const handleSend = async () => {
    if (!message.trim() || recipients.length === 0) return
    setSending(true)
    setSent(0)
    setFailed([])
    setDone(false)
    const headers = getAuthHeaders({ 'Content-Type': 'application/json' })
    let ok = 0
    const errs: string[] = []
    // Send sequentially to avoid flooding the server with concurrent requests.
    for (const u of recipients) {
      try {
        const res = await fetch(`${API_URL}/api/dm/${u.id}`, {
          method: 'POST',
          headers,
          body: JSON.stringify({ content: message, message_type: 'broadcast' }),
        })
        if (res.ok) {
          ok++
          setSent(ok)
        } else {
          errs.push(u.display_name || u.name || u.email)
        }
      } catch {
        errs.push(u.display_name || u.name || u.email)
      }
    }
    setFailed(errs)
    setDone(true)
    setSending(false)
  }

  const handleClose = () => {
    if (sending) return
    onClose()
  }

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: 520 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
          <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
            <MegaphoneIcon size={18} /> Broadcast
          </h3>
          <button className="icon-btn" onClick={handleClose} disabled={sending}><XIcon size={16} /></button>
        </div>
        <p style={{ fontSize: 13, color: 'var(--text-muted, #888)', margin: '0 0 12px' }}>
          Envia a mesma mensagem direta para <strong>{recipients.length}</strong>
          {' '}{recipients.length === 1 ? 'pessoa' : 'pessoas'}.
        </p>
        <textarea
          value={message}
          onChange={e => setMessage(e.target.value)}
          placeholder="Digite a mensagem para todos..."
          rows={5}
          disabled={sending}
          style={{
            width: '100%', resize: 'vertical', fontFamily: 'inherit',
            padding: '8px 10px', borderRadius: 6,
            background: 'var(--bg-input, #0a0a12)',
            border: '1px solid var(--border, #333)',
            color: 'var(--text, #e0e0e0)', fontSize: 13, outline: 'none',
          }}
        />
        {sending && (
          <div style={{ marginTop: 10, fontSize: 12, color: 'var(--text-muted, #888)' }}>
            Enviando... {sent}/{recipients.length}
          </div>
        )}
        {done && (
          <div style={{ marginTop: 10, fontSize: 12 }}>
            <span style={{ color: '#17b817' }}>✓ {sent} enviada(s)</span>
            {failed.length > 0 && (
              <span style={{ color: '#f85149', display: 'block', marginTop: 4 }}>
                Falha para: {failed.join(', ')}
              </span>
            )}
          </div>
        )}
        <div className="profile-modal-actions" style={{ marginTop: 14 }}>
          <button type="button" className="btn-ghost" onClick={handleClose} disabled={sending}>
            {done ? 'Fechar' : 'Cancelar'}
          </button>
          <button
            type="button"
            className="btn-primary"
            onClick={handleSend}
            disabled={sending || !message.trim() || recipients.length === 0}
            style={{ display: 'flex', alignItems: 'center', gap: 6 }}
          >
            <SendIcon size={14} />
            {sending ? 'Enviando...' : `Enviar para ${recipients.length}`}
          </button>
        </div>
      </div>
    </div>
  )
}
